module.exports = window["Bernie_l10nBundle_sv_SE"];